import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSquarePlus, faXmarkSquare} from '@fortawesome/free-solid-svg-icons';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../services/api.service';
import {ToastrService} from 'ngx-toastr';

// import { getUpdatedFieldsFormData } from '../../../common/utils';

@Component({
    selector: 'app-edit-camera',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './edit-camera.component.html',
    styleUrl: './edit-camera.component.css'
})
export class EditCameraComponent implements OnInit {
  updateCameraForm!: FormGroup;
  errorMessage: []  = [];;
  directionChoice: any  = [
                    'ENTRY',
      'EXIT',
      'BIDIRECTIONAL'
                  ];          
                    
  orgId!:number;
  // orgName!:string;

  constructor(private apiService: ApiService, 
                private router: Router,
                private toastr:ToastrService,
                private route: ActivatedRoute,
                private fb: FormBuilder,
                library: FaIconLibrary,
                ) {
      library.addIcons(faXmarkSquare, faSquarePlus)
      
      this.updateCameraForm = fb.group({
        cameraESN: ['', 
                      Validators.required, 
                      
                    ],
        organization: ['', Validators.required],
        direction: ['', Validators.required],
        description: ['', [
                        Validators.required, 
                      ]
                  ],
       
  
      });
    }

   ngOnInit(): void {
      let pk = this.route.snapshot.paramMap.get('pk');
      this.route.queryParams.subscribe(params => {
      this.orgId = params['org_id'];
      // this.orgName = params['org_name'];
    });

      this.getCameraDetail(pk);
  }
    // validateNumericInput(event: Event): void {
    //   const input = event.target as HTMLInputElement;
    //   input.value = input.value.replace(/[^0-9]/g, '');
    //   this.updateCameraForm.get('mobileNo')?.setValue(input.value);
    // }
  
    getCameraDetail(pk:any){
      this.apiService.getCamera(pk, this.orgId).subscribe({
        next: (res:any) => {
          this.updateCameraForm = this.fb.group({
            cameraESN: [res['camera_esn'],[
                    Validators.required,
            ]],
            organization:[res['organization'], Validators.required],
            direction: [res['direction'], Validators.required],
            description: [res['description'], Validators.required],

        })
      },
      error: (err) =>{
        
      }
      })
  
    }
    onSubmit() {
      // debugger;
      if (this.updateCameraForm.valid) {
        let formdata = new FormData();
        formdata.append('camera_esn', this.updateCameraForm.value.cameraESN);
        formdata.append('organization', this.updateCameraForm.value.organization);
        formdata.append('direction', this.updateCameraForm.value.direction);
        formdata.append('description', this.updateCameraForm.value.description);
       
        let pk:any = this.route.snapshot.paramMap.get('pk');
        this.apiService.updateCamera(pk, this.orgId, formdata).subscribe({
            next: (response:any) => {
              this.toastr.success("Camera Updated successfully.", 'Success');
              this.router.navigate(['/view-cameras'], { queryParams: {'id': this.orgId, }});
            },
            error: (err) => {
              if (err['error']['non_field_errors']) {
                err['error']['non_field_errors'].forEach((element:any) => {
                  this.toastr.error(element, 'Error');
                });
              } else if (err['error']['camera_esn']) {
                err['error']['camera_esn'].forEach((element:any) => {
                  this.toastr.error(element, 'Error');
                });
              } else if (err['error']['organization']) {
                err['error']['organization'].forEach((element:any) => {
                  this.toastr.error(element, 'Error');
                });
              } else if (err['error']['direction']) {
                err['error']['direction'].forEach((element:any) => {
                  this.toastr.error(element, 'Error');
                });
              }else if (err['error']['description']) {
                err['error']['description'].forEach((element:any) => {
                  this.toastr.error(element, 'Error');
                });
              }
               else if (err['status'] !== 403 && err.status !== 0) {
                this.toastr.error("Something went wrong!", 'Error');
              }
            }
          }
        )
      } else {
        this.validateAllFormFields(this.updateCameraForm);
      }
    }
    validateAllFormFields(formGroup: FormGroup) {   
      Object.keys(formGroup.controls).forEach(field => {  
        const control = formGroup.get(field);             
        if (control instanceof FormGroup) {        
          this.validateAllFormFields(control);            
        } else {                                      
          control?.markAsTouched({ onlySelf: true });
        }
      });
    }
  
    onCancel(organization: string) {
      // Handle cancel action

      this.router.navigate(['/view-cameras'], { queryParams: {'id': this.orgId, 'name': organization}});
    }
}
